if(document.querySelector('.jsTeacherItem')){
    let jsTeacherItem = document.querySelectorAll('.jsTeacherItem');
    let jsTeacherMore = document.querySelector('.jsTeacherMore')

    jsTeacherMore.addEventListener('click', function(e){
        e.preventDefault()
        jsTeacherMore.style.display = 'none';
        for (let index = 0; index < jsTeacherItem.length; index++){
            let item = jsTeacherItem[index];
            item.style.display = 'block';
        }
    })
}